import { Component, EventEmitter, Input, model, OnInit, Output } from '@angular/core';
import { Job } from '../../job.model';
import { Project } from '../../../../project.model';
import { Attachment } from '../../../../../core/attachment/attachment.model';
import { LoggerService } from '../../../../../core/logger/logger.service';

@Component({
    selector: 'app-job-signature',
    templateUrl: './job-signature.component.html',
    styleUrls: ['./job-signature.component.scss'],
})
export class JobSignatureComponent {
    @Input() job: Job;
    @Input() project: Project;
    @Input() changesAllowed = false;
    @Output() lockJob = new EventEmitter();

    constructor(private logger: LoggerService) {}

    /**
     * Triggered when the user has confirmed a signature via the app-signature component
     */
    onSignatureAdded(signature: Attachment) {
        this.logger.log('[JOB SIGNATURE COMPONENT] signature added', signature);
        this.job.signatures.push(signature);
        this.lockJob.emit(true);
    }

    /**
     * Triggered when the user wants to remove an existing signature from the job
     * @param signatureIndex
     */
    onSignatureRemoved(signatureIndex: number) {
        this.job.signatures.splice(signatureIndex, 1);
    }
}
